import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    projId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projMonitor.buildZip, {
        projId,
    }, options);
    if (error) return { error, status };
    return content || { url: '' };
};
